import { styled } from '@linaria/react';
import React from 'react'

const Container = styled.div<BulletProps>`
  display:block;
  position:relative;
  padding-left:30px;
  margin-bottom:24px;

`;
const IconContainer = styled.span<BulletProps>`
  display: inline-block;
  text-align:center;
  position: absolute;
  left: 0;
  top: ${props=>props.variant? (props.variant === "error" ? "3px" : "0") : "0"};
  color:#5C596D;
  & svg {
    width:${props=>props.variant? (props.variant === "error" ? "16px" : "7px") : "7px"};;
    height:${props=>props.variant? (props.variant === "error" ? "16px" : "7px") : "7px"};;
  }
`;


export interface BulletProps{
    children: React.ReactNode;  
    className?: string | undefined;
    id?: string | undefined;
    variant?: "default" | "error" | "nobullet" ;
}

function Bullet({className,id,children,variant="default"}:BulletProps) {
  return (
    <Container className={className} id={id}>
      <IconContainer variant={variant} >
        {variant === 'default' && <svg viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="4.5" cy="4.5" r="3.25" fill="currentColor"/>
        </svg>}
        {variant === 'error' && <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M9.47266 16.7578C13.6148 16.7578 16.9727 13.3999 16.9727 9.25781C16.9727 5.11568 13.6148 1.75781 9.47266 1.75781C5.33052 1.75781 1.97266 5.11568 1.97266 9.25781C1.97266 13.3999 5.33052 16.7578 9.47266 16.7578ZM9.47266 18.2578C14.4432 18.2578 18.4727 14.2284 18.4727 9.25781C18.4727 4.28725 14.4432 0.257812 9.47266 0.257812C4.50209 0.257812 0.472656 4.28725 0.472656 9.25781C0.472656 14.2284 4.50209 18.2578 9.47266 18.2578Z" fill="#C50000"/>
          <path d="M9.86638 11.8833L10.1852 5.50688C10.2056 5.09937 9.88067 4.75781 9.47266 4.75781C9.06464 4.75781 8.73973 5.09937 8.76011 5.50688L9.07893 11.8833C9.08942 12.0931 9.26259 12.2578 9.47266 12.2578C9.68273 12.2578 9.85589 12.0931 9.86638 11.8833Z" fill="#C50000"/>
          <circle cx="9.47266" cy="13.7578" r="0.75" fill="#C50000"/>
          </svg>}
      </IconContainer>
      {children}
    </Container>
  )
}

export default Bullet;